export class NotificationHandler {
}
export const PUSH_TOKEN_KEY = 'push-token';
